module.exports = __webpack_public_path__ + "img/12.5fbfdbb1.png";